import styled, { css } from 'styled-components';

import Text from 'components/core/typography/Text';
import { BannerStyle } from 'enums/bannerStyle';
import { variants } from 'utils/styledUtils';

import { DIVIDER } from 'styles/color';
import {
  BORDER_RADIUS_200,
  FONT_SIZE_14,
  FONT_WEIGHT_MEDIUM,
  FONT_WEIGHT_REGULAR,
  LETTER_SPACING_DENSE,
  NEUTRAL_0,
  NEUTRAL_050,
  NEUTRAL_800,
  RED_500,
  SPACE_200,
  SPACE_300,
  SPACE_400,
  Z_INDEX_5,
} from 'styles/tokens';
import { LINE_HEIGHT_DEFAULT } from 'styles/typography';

export const FlexRow = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: ${SPACE_200};
  width: 100%;
`;

export const TextContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  min-width: 0;
  width: 100%;
`;

export const BannerContainer = styled.div<{ $styleVariant?: BannerStyle }>`
  border: 1px solid ${DIVIDER};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: ${SPACE_200} ${SPACE_400} ${SPACE_200} ${SPACE_300};
  width: 100%;

  ${Text} {
    font-size: ${FONT_SIZE_14};
    font-style: normal;
    font-weight: ${FONT_WEIGHT_REGULAR};
    letter-spacing: ${LETTER_SPACING_DENSE};
    line-height: ${LINE_HEIGHT_DEFAULT};
    text-transform: none;
    white-space: normal;
  }

  ${variants<BannerStyle>('$styleVariant', {
    [BannerStyle.IMPERSONATION]: css`
      background: ${RED_500};
      border: none;
      color: ${NEUTRAL_0};
      z-index: ${Z_INDEX_5};
      ${Text} {
        color: ${NEUTRAL_0};
      }
      ${TextContainer} {
        gap: ${SPACE_200};
        justify-content: center;
      }
    `,
    [BannerStyle.NEUTRAL]: css`
      background: ${NEUTRAL_050};
      border-radius: ${BORDER_RADIUS_200};
      color: ${NEUTRAL_800};
      ${Text} {
        color: ${NEUTRAL_800};
      }
    `,
    [BannerStyle.WARNING]: css`
      background: ${RED_500};
      color: ${NEUTRAL_0};
      ${Text} {
        color: ${NEUTRAL_0};
      }
    `,
  })}
`;

export const BannerLink = styled(Text)`
  display: flex;
  font-style: normal;
  font-weight: ${FONT_WEIGHT_MEDIUM};
  text-decoration: underline;
`;
